import LocalStorageService from "../services/LocalStorageService.service";
const logoutFuntion = () => {
    LocalStorageService.clear();
    window.location.href = "/auth";
};

export { logoutFuntion };
